import React from 'react';
import { BookOpen, Check, Star, Gift, Monitor, Palette, BarChart, Shield } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full" data-id="element-362">
      {/* Product Presentation */}
      <div className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-363">
        <div className="max-w-5xl mx-auto" data-id="element-364">
          <div className="text-center mb-12" data-id="element-365">
            <h2 className="text-3xl sm:text-5xl font-black text-navy mb-4" data-id="element-366">
              RUTA IT USA: EL SALTO DE $0 A $70K
            </h2>
            <h3 className="text-xl sm:text-2xl font-medium text-brandBlue mb-8" data-id="element-367">
              La Guía Maestra para Inmigrantes Hispanos en EE.UU.
            </h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-368">
              Una guía digital completa, paso a paso, que te lleva desde tu
              situación actual hasta tu primer empleo en tecnología, usando las
              certificaciones profesionales de Google como trampolín.
            </p>
          </div>

          {/* Offer Stack */}
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 sm:p-10 mb-16" data-id="element-369">
            <div className="flex items-center mb-8 pb-6 border-b border-gray-200" data-id="element-370">
              <BookOpen className="h-10 w-10 text-brandBlue mr-4" data-id="element-371" />
              <h3 className="text-2xl sm:text-3xl font-bold text-navy" data-id="element-372">
                El Libro Digital Completo{' '}
                <span className="text-brandRed line-through text-lg ml-2" data-id="element-373">
                  ($27 valor)
                </span>
              </h3>
            </div>

            <p className="text-xl font-medium text-gray-700 mb-8" data-id="element-374">
              Todo el sistema en un solo PDF accionable:
            </p>

            <div className="space-y-8" data-id="element-375">
              {/* Chapter 1 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandBlue" data-id="element-376">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-377">
                  🟦 Capítulo 1: La Nueva Economía de las Credenciales
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-378">
                  <li className="flex items-start" data-id="element-379">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-380" />{' '}
                    Por qué el título universitario ya no es el único camino en
                    EE.UU.
                  </li>
                  <li className="flex items-start" data-id="element-381">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-382" />{' '}
                    Cómo funciona el "Puente de Certificación" y por qué es tu
                    mejor opción.
                  </li>
                </ul>
              </div>

              {/* Chapter 2 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandRed" data-id="element-383">
                <h4 className="text-xl font-bold text-navy mb-4" data-id="element-384">
                  🟥 Capítulo 2: Elige Tu Ruta (Con Links de Inscripción)
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-385">
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-386">
                    <Monitor className="h-5 w-5 text-brandBlue mr-3" data-id="element-387" />
                    <div data-id="element-388">
                      <span className="font-bold" data-id="element-389">IT Support</span> <br data-id="element-390" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-391">
                        $50k-$60k/año
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-392">
                    <Palette className="h-5 w-5 text-purple-500 mr-3" data-id="element-393" />
                    <div data-id="element-394">
                      <span className="font-bold" data-id="element-395">UX Design</span> <br data-id="element-396" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-397">
                        $65k-$80k/año
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-398">
                    <BarChart className="h-5 w-5 text-brandGold mr-3" data-id="element-399" />
                    <div data-id="element-400">
                      <span className="font-bold" data-id="element-401">Data Analytics</span> <br data-id="element-402" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-403">
                        $60k-$75k/año
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded flex items-center" data-id="element-404">
                    <Shield className="h-5 w-5 text-brandRed mr-3" data-id="element-405" />
                    <div data-id="element-406">
                      <span className="font-bold" data-id="element-407">Cybersecurity</span> <br data-id="element-408" />
                      <span className="text-sm text-green-600 font-medium" data-id="element-409">
                        $70k-$90k+/año
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Chapter 3 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandGold" data-id="element-410">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-411">
                  🟨 Capítulo 3: Cómo Estudiar Gratis o por Menos de $150
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-412">
                  <li className="flex items-start" data-id="element-413">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-414" />{' '}
                    El secreto de la "Financial Aid" de Coursera que casi nadie
                    conoce.
                  </li>
                  <li className="flex items-start" data-id="element-415">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-416" />{' '}
                    Cómo terminar en 90 días invirtiendo menos de $150 total.
                  </li>
                </ul>
              </div>

              {/* Chapter 4 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-green-500" data-id="element-417">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-418">
                  🟩 Capítulo 4: Inglés Técnico de Supervivencia
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-419">
                  <li className="flex items-start" data-id="element-420">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-421" />{' '}
                    El Diccionario de Poder: las 50 palabras que necesitas
                    dominar.
                  </li>
                  <li className="flex items-start" data-id="element-422">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-423" />{' '}
                    Scripts exactos para llamadas de soporte técnico en inglés.
                  </li>
                  <li className="flex items-start" data-id="element-424">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-425" />{' '}
                    Método de inmersión pasiva para aprender mientras trabajas.
                  </li>
                </ul>
              </div>

              {/* Chapter 5 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandBlue" data-id="element-426">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-427">
                  🟦 Capítulo 5: Guía Maestra del Currículum USA (Formato ATS)
                </h4>
                <ul className="space-y-2 text-gray-600 mb-4" data-id="element-428">
                  <li className="flex items-start" data-id="element-429">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-430" />{' '}
                    Estructura exacta del CV americano (sin foto, sin diseño).
                  </li>
                  <li className="flex items-start" data-id="element-431">
                    <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-432" />{' '}
                    Cómo traducir experiencia en construcción o limpieza a
                    habilidades técnicas.
                  </li>
                </ul>
                <p className="font-medium text-navy mt-4 mb-2" data-id="element-433">
                  Directorio de agencias de reclutamiento:
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-434">
                  <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2.5 py-0.5 rounded" data-id="element-435">
                    Robert Half
                  </span>
                  <span className="bg-red-100 text-red-800 text-xs font-bold px-2.5 py-0.5 rounded" data-id="element-436">
                    TEKsystems
                  </span>
                  <span className="bg-yellow-100 text-yellow-800 text-xs font-bold px-2.5 py-0.5 rounded" data-id="element-437">
                    Insight Global
                  </span>
                </div>
              </div>

              {/* Chapter 6 */}
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-brandRed" data-id="element-438">
                <h4 className="text-xl font-bold text-navy mb-3" data-id="element-439">
                  🟥 Capítulo 6: El Consorcio de Empleadores VIP
                </h4>
                <p className="text-gray-600 mb-4" data-id="element-440">
                  La lista completa de empresas que buscan graduados de Google y
                  cómo acceder al portal de empleo exclusivo.
                </p>
                <div className="grid grid-cols-2 gap-2 text-sm text-gray-600" data-id="element-441">
                  <div data-id="element-442">
                    <span className="text-brandBlue font-bold" data-id="element-443">
                      🔵 Tecnología:
                    </span>{' '}
                    Google, Dell, Intel...
                  </div>
                  <div data-id="element-444">
                    <span className="text-brandRed font-bold" data-id="element-445">
                      🔴 Finanzas:
                    </span>{' '}
                    Bank of America, Deloitte...
                  </div>
                  <div data-id="element-446">
                    <span className="text-brandGold font-bold" data-id="element-447">🟡 Retail:</span>{' '}
                    Target, Walmart, Best Buy...
                  </div>
                  <div data-id="element-448">
                    <span className="text-green-600 font-bold" data-id="element-449">
                      🟢 Salud/Media:
                    </span>{' '}
                    CVS Health, Hulu...
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bonuses */}
          <div className="mt-20" data-id="element-450">
            <div className="text-center mb-12" data-id="element-451">
              <h2 className="text-3xl sm:text-4xl font-black text-navy mb-4" data-id="element-452">
                Pero Eso No Es Todo Lo Que Recibes Hoy...
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-453">
                Cuando inviertes tus $27 hoy, no solo recibes la Guía Maestra.
                <br data-id="element-454" />
                Recibes{' '}
                <strong className="text-brandRed" data-id="element-455">
                  3 herramientas adicionales que valen $52 combinadas
                </strong>
                ... y son completamente GRATIS.
              </p>
            </div>

            <div className="space-y-12" data-id="element-456">
              {/* Bonus 1 */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col md:flex-row" data-id="element-457">
                <div className="md:w-2/5 bg-navy-900 p-8 flex items-center justify-center" data-id="element-458">
                  <img src="https://cdn.magicpatterns.com/uploads/ps9ajijnnCM9YkojgjuaM4/bono_1.png" alt="Checklist 90 Días a IT" className="max-w-full h-auto rounded shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-300" data-id="element-459" />
                </div>
                <div className="md:w-3/5 p-8 sm:p-10" data-id="element-460">
                  <div className="inline-block bg-brandGold text-white font-bold px-3 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-461">
                    Bono #1
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-navy mb-2" data-id="element-462">
                    Checklist "90 Días a IT"
                  </h3>
                  <h4 className="text-xl text-gray-500 font-medium mb-4" data-id="element-463">
                    Ruta Semanal Anti-Excusas
                  </h4>

                  <div className="flex items-center mb-6 bg-red-50 inline-flex px-4 py-2 rounded-lg" data-id="element-464">
                    <span className="text-gray-500 line-through mr-2 font-medium" data-id="element-465">
                      Valor: $17
                    </span>
                    <span className="text-brandRed font-bold text-lg" data-id="element-466">
                      → GRATIS hoy
                    </span>
                  </div>

                  <div className="text-gray-700 mb-6 space-y-4" data-id="element-467">
                    <p data-id="element-468">
                      ¿Sabes cuál es el enemigo #1 de la gente que quiere
                      cambiar de carrera?
                    </p>
                    <p data-id="element-469">
                      No es el tiempo. No es el inglés. No es la falta de
                      dinero.
                    </p>
                    <p className="font-bold text-navy" data-id="element-470">
                      Es no saber qué hacer mañana por la mañana.
                    </p>
                    <p data-id="element-471">
                      Este checklist elimina ese problema para siempre. Cuando
                      abras este documento, no tendrás que pensar. Solo
                      ejecutar.
                    </p>
                  </div>

                  <ul className="space-y-3 mb-8" data-id="element-472">
                    <li className="flex items-start" data-id="element-473">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-474" />
                      <span className="text-gray-700 font-medium" data-id="element-475">
                        Semana 1 a Semana 12 mapeadas (micro-tareas diarias
                        Lun–Dom)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-476">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-477" />
                      <span className="text-gray-700 font-medium" data-id="element-478">
                        Plan 30/60/90 imprimible para pegar en tu pared o
                        pantalla
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-479">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-480" />
                      <span className="text-gray-700 font-medium" data-id="element-481">
                        Tracker de hábitos (estudio + inglés + aplicaciones)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-482">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-483" />
                      <span className="text-gray-700 font-medium" data-id="element-484">
                        Protocolo Anti-Excusas para cuando falles 3 días
                        seguidos
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-485">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-486" />
                      <span className="text-gray-700 font-medium" data-id="element-487">
                        La versión de 20 minutos para los días que llegas muerto
                        del trabajo
                      </span>
                    </li>
                  </ul>

                  <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-brandGold italic text-gray-600 font-medium" data-id="element-488">
                    "No necesitas motivación cuando tienes un plan. Este
                    checklist es ese plan."
                  </div>
                </div>
              </div>

              {/* Bonus 2 */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col md:flex-row-reverse" data-id="element-489">
                <div className="md:w-2/5 bg-navy-900 p-8 flex items-center justify-center" data-id="element-490">
                  <img src="https://cdn.magicpatterns.com/uploads/jSMyXyspL9cddRRovihhDA/bono_2.png" alt="Guion de Entrevista Hispano a Prueba" className="max-w-full h-auto rounded shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-300" data-id="element-491" />
                </div>
                <div className="md:w-3/5 p-8 sm:p-10" data-id="element-492">
                  <div className="inline-block bg-brandGold text-white font-bold px-3 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-493">
                    Bono #2
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-navy mb-2" data-id="element-494">
                    Guion de Entrevista "Hispano a Prueba"
                  </h3>
                  <h4 className="text-xl text-gray-500 font-medium mb-4" data-id="element-495">
                    10 Preguntas + Respuestas Modelo EN/ES
                  </h4>

                  <div className="flex items-center mb-6 bg-red-50 inline-flex px-4 py-2 rounded-lg" data-id="element-496">
                    <span className="text-gray-500 line-through mr-2 font-medium" data-id="element-497">
                      Valor: $18
                    </span>
                    <span className="text-brandRed font-bold text-lg" data-id="element-498">
                      → GRATIS hoy
                    </span>
                  </div>

                  <div className="text-gray-700 mb-6 space-y-4" data-id="element-499">
                    <p data-id="element-500">Imagina que mañana te llaman para una entrevista.</p>
                    <p data-id="element-501">
                      ¿Sabrías qué decir cuando te pregunten "Tell me about
                      yourself" en inglés? ¿O cuando te digan "What are your
                      weaknesses?"
                    </p>
                    <p data-id="element-502">
                      La mayoría se congela. Se pone rojo. Dice algo vago. Y
                      pierde el trabajo.
                    </p>
                    <p className="font-bold text-navy" data-id="element-503">
                      No tú. No después de leer este guion.
                    </p>
                    <p data-id="element-504">
                      Este bono te da las respuestas exactas, en inglés simple y
                      directo, para las 10 preguntas más comunes en entrevistas
                      de IT en EE.UU.
                    </p>
                  </div>

                  <ul className="space-y-3 mb-8" data-id="element-505">
                    <li className="flex items-start" data-id="element-506">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-507" />
                      <span className="text-gray-700 font-medium" data-id="element-508">
                        10 preguntas reales con respuestas modelo en inglés Y
                        español
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-509">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-510" />
                      <span className="text-gray-700 font-medium" data-id="element-511">
                        El método C.L.A.R.O. para estructurar cualquier
                        respuesta en 30–60 segundos
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-512">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-513" />
                      <span className="text-gray-700 font-medium" data-id="element-514">
                        Frases salvavidas para cuando no entiendes la pregunta
                        (sin pánico)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-515">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-516" />
                      <span className="text-gray-700 font-medium" data-id="element-517">
                        Script de cierre profesional para pedir el trabajo con
                        confianza
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-518">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-519" />
                      <span className="text-gray-700 font-medium" data-id="element-520">
                        Flashcards imprimibles para practicar donde sea
                      </span>
                    </li>
                  </ul>

                  <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-brandGold italic text-gray-600 font-medium" data-id="element-521">
                    "Tu acento no te va a costar el trabajo. Llegar sin
                    preparación, sí."
                  </div>
                </div>
              </div>

              {/* Bonus 3 */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col md:flex-row" data-id="element-522">
                <div className="md:w-2/5 bg-navy-900 p-8 flex items-center justify-center" data-id="element-523">
                  <img src="https://cdn.magicpatterns.com/uploads/jpi3i7DuJD7TfeZvbXSdRy/bono_3.png" alt="Plantilla Resume ATS 1 Página Imparable" className="max-w-full h-auto rounded shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-300" data-id="element-524" />
                </div>
                <div className="md:w-3/5 p-8 sm:p-10" data-id="element-525">
                  <div className="inline-block bg-brandGold text-white font-bold px-3 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-526">
                    Bono #3
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-navy mb-2" data-id="element-527">
                    Plantilla Resume ATS "1 Página Imparable"
                  </h3>
                  <h4 className="text-xl text-gray-500 font-medium mb-4" data-id="element-528">
                    Copy/Paste + 3 Variantes Listas
                  </h4>

                  <div className="flex items-center mb-6 bg-red-50 inline-flex px-4 py-2 rounded-lg" data-id="element-529">
                    <span className="text-gray-500 line-through mr-2 font-medium" data-id="element-530">
                      Valor: $17
                    </span>
                    <span className="text-brandRed font-bold text-lg" data-id="element-531">
                      → GRATIS hoy
                    </span>
                  </div>

                  <div className="text-gray-700 mb-6 space-y-4" data-id="element-532">
                    <p data-id="element-533">
                      ¿Sabes por qué el 75% de los resumes nunca llegan a ojos
                      humanos?
                    </p>
                    <p className="font-bold text-navy" data-id="element-534">
                      Porque los filtra un robot llamado ATS (Applicant Tracking
                      System).
                    </p>
                    <p data-id="element-535">
                      Y si tu resume tiene foto, columnas, gráficos o el formato
                      incorrecto... El robot lo borra automáticamente. Sin
                      leerlo. Sin importar qué tan bueno eres.
                    </p>
                    <p data-id="element-536">
                      Esta plantilla fue diseñada específicamente para pasar ese
                      filtro Y sonar corporativo.
                    </p>
                  </div>

                  <ul className="space-y-3 mb-8" data-id="element-537">
                    <li className="flex items-start" data-id="element-538">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-539" />
                      <span className="text-gray-700 font-medium" data-id="element-540">
                        Plantilla base lista para copiar y pegar (formato ATS
                        aprobado)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-541">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-542" />
                      <span className="text-gray-700 font-medium" data-id="element-543">
                        3 variantes de "Professional Summary" según tu perfil y
                        experiencia
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-544">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-545" />
                      <span className="text-gray-700 font-medium" data-id="element-546">
                        Banco de bullets profesionales que traducen
                        construcción/limpieza a lenguaje de oficina corporativa
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-547">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-548" />
                      <span className="text-gray-700 font-medium" data-id="element-549">
                        Lista de Skills pre-armada por ruta (IT / UX / Data /
                        Cyber)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-550">
                      <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" data-id="element-551" />
                      <span className="text-gray-700 font-medium" data-id="element-552">
                        Checklist ATS final para no cometer el error que te
                        borra del sistema
                      </span>
                    </li>
                  </ul>

                  <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-brandGold italic text-gray-600 font-medium" data-id="element-553">
                    "Tu resume no tiene que ser bonito. Tiene que pasar el
                    robot. Esta plantilla hace exactamente eso."
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}